import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

(function Slider () {

  const sliderS1028 = new Swiper('.slider-s1028', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 12,
    slideClass: 'slider-cell',
    updateOnWindowResize: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next-s1028',
      prevEl: '.swiper-button-prev-s1028',
    },
    pagination: {
      el: '.swiper-pagination-s1028',
    },
    breakpoints: {
      1280: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
      800: {
        slidesPerView: 2,
        spaceBetween: 24,
      }
    }
  })

})()
